import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constructor(private logger: NGXLogger) { }

  logError(message: string, stack: string) {

    const username = localStorage.getItem("userId") ?? "";

    this.logger.error(message, this.conDispositivo(stack), username);
    }

  /**
   * Registra un'informazione diagnostica. Finisce nella stessa tabella AppLogs
   * dei log di errore, perche' serverLogLevel e' TRACE: utile per confrontare
   * cio' che il client vede con cio' che il server riceve.
   */
  logInfo(message: string, dettaglio: string) {

    const username = localStorage.getItem("userId") ?? "";

    this.logger.info(message, this.conDispositivo(dettaglio), username);
  }

  /**
   * Accoda lo User-Agent al testo destinato alla colonna Stack di AppLog. E' l'unico
   * posto disponibile: `AppLogsController.Post` mappa solo i primi due `additional`
   * (stack e username) e la tabella non ha un campo per il dispositivo. Senza questo
   * dato non si distingue un difetto dell'applicazione da uno del dispositivo, come
   * "Object.hasOwn is not a function", che riguarda le versioni di iOS anteriori alla
   * 15.4. La colonna e' nvarchar(MAX), quindi non c'e' rischio di troncamento.
   */
  private conDispositivo(testo: string): string {

    const dispositivo = 'User-Agent: ' + navigator.userAgent;

    return testo ? testo + '\n\n' + dispositivo : dispositivo;
  }
}
